export const giveBadge = context => (data) => ({
    type: "WITNESS.BADGE",
    payload: {
        data
    },
    context
})